import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

// Import custom components
import { ConichiCheckboxGroupComponent } from './checkbox_group.component';


@NgModule({
  imports: [ BrowserModule ],
  exports: [ ConichiCheckboxGroupComponent ],
  declarations: [ ConichiCheckboxGroupComponent ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ConichiCheckboxGroupModule { }
